import { Component, computed, inject, OnDestroy, output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { vendorReviewQrForm } from '@app/modules/user-management/forms/vendor-supplier-onboarding/review-qr/review-qr.form';
import { CompaniesService } from '@app/modules/user-management/services/companies/companies.service';
import { ToastService } from '@app/services/toast/toast.service';
import { AppStore } from '@app/stores/app/app.store';
import { CompanyStore } from '@app/stores/company/company.store';
import { IDynamicActions } from '@app/types/dynamic-actions';
import { Subscription } from 'rxjs';
import { ReviewQrDetailsComponent } from '../review-qr-details/review-qr-details.component';

@Component({
    selector: 'app-review-qr',
    imports: [
        MatFormFieldModule,
        FormsModule,
        MatDatepickerModule,
        MatIconModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatTooltipModule,
        ReviewQrDetailsComponent,
    ],
    templateUrl: './review-qr.component.html',
    styleUrl: './review-qr.component.scss',
})
export class ReviewQrComponent implements OnDestroy {
    private companyService = inject(CompaniesService);
    private toastService = inject(ToastService);
    private appStore = inject(AppStore);
    translate = this.appStore.i18n;
    fg = vendorReviewQrForm();
    companyStore = inject(CompanyStore);
    onClose = output();
    onBack = output();
    state = signal({
        isSaving: false,
    });
    subs$ = new Subscription();

    actions = computed<IDynamicActions[]>(() => {
        const isSaving = this.state().isSaving;
        const { ACTION__Done } = this.translate();
        return [
            {
                type: 'flat',
                text: ACTION__Done,
                class: '',
                testId: 'finish-btn',
                disabled: isSaving,
                isBusy: isSaving,
                onClick: this.onClickClose.bind(this),
            },
        ];
    });

    ngOnDestroy(): void {
        this.subs$.unsubscribe();
    }

    onClickClose() {
        this.onClose.emit();
    }
}
